import { cn } from '@skin-seoul/design-system';
import { forwardRef } from 'react';

interface SectionTitleProps {
  theme: 'light' | 'dark';
  children: React.ReactNode;
}

interface SectionSubTitleProps {
  theme?: 'light' | 'dark';
  children: React.ReactNode;
}

export const CampaignSectionTitle = forwardRef<HTMLHeadingElement, SectionTitleProps>(
  ({ theme, children, ...props }, ref) => (
    <h2
      ref={ref}
      className={cn('text-heading-h5 font-medium m-0', theme === 'light' ? 'text-[#14101B]' : 'text-white')}
      {...props}
    >
      {children}
    </h2>
  ),
);

CampaignSectionTitle.displayName = 'SectionTitle';

export const CampaignSectionSubTitle = forwardRef<HTMLParagraphElement, SectionSubTitleProps>(
  ({ theme = 'light', children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn('text-paragraph-medium font-normal', theme === 'light' ? 'text-[#9D9BA1]' : 'text-[#bbbabe]')}
      {...props}
    >
      {children}
    </span>
  ),
);

CampaignSectionSubTitle.displayName = 'SectionSubTitle';
